//import React from 'react'
import { Header, Footer, Content } from "./index";
import { Box, Toolbar, Container } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import ScrollToTop from "./scroolTop";
import { storeStateType } from "../redux/store";
import { useSelector } from "react-redux";
//import { Outlet } from 'react-router';

const Layout = () => {
  const { themeMode } = useSelector((state: storeStateType) => state.UI);

  const lightTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
    palette: {
      mode: "light",
      background: {
        default: "#EBEDF2",
        paper: "#ffffff",
      },
      primary: {
        main: "#6b6efe",
      },
      secondary: {
        main: "#6b6efe",
      },
      success: {
        main: "#4caf50",
      },
      warning: { main: "#ff9800" },
      error: { main: "#f44336" },
      text: {
        primary: "#1f2937",
        secondary: "#56687c",
      },
    },
    typography: {
      fontFamily: "sans-serif",
      h1: {
        color: "#1f2937",
      },
      h2: {
        color: "#1f2937",
      },
      h3: {
        color: "#1f2937",
      },
      h4: {
        color: "#1f2937",
      },
      h5: {
        color: "#1f2937",
      },
      h6: {
        color: "#1f2937",
      },
      subtitle1: {
        color: "#1f1910",
      },
      subtitle2: {
        color: "#1f1910",
      },
      body1: {
        color: "#1f1910",
      },
      body2: {
        color: "#1f1910",
      },
      button: {
        color: "#1f1910",
      },
      caption: {
        color: "#1f1910",
      },
      overline: {
        color: "#1f1910",
      },
    },
    components: {
      //buttons for light modes
      MuiButton: {
        variants: [
          {
            props: { variant: "contained", color: "primary" },
            style: {
              backgroundColor: "#3f51b5",
              color: "#ffffff",
            },
          },
          {
            props: { variant: "outlined", color: "primary" },
            style: {
              borderColor: "#3f51b5",
              color: "#3f51b5",
            },
          },
          {
            props: { variant: "text", color: "primary" },
            style: {
              color: "#3f51b5",
            },
          },
          {
            props: { variant: "contained", color: "secondary" },
            style: {
              backgroundColor: "#f50057",
              color: "#ffffff",
            },
          },
          {
            props: { variant: "outlined", color: "secondary" },
            style: {
              borderColor: "#f50057",
              color: "#f50057",
            },
          },
          {
            props: { variant: "text", color: "secondary" },
            style: {
              color: "#f50057",
            },
          },
        ],
      },
    },
  });
  const darkTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
    palette: {
      mode: "dark",
      background: {
        default: "#26292B",
        paper: "#2E3239",
      },
      primary: {
        main: "#6366f1",
      },
      secondary: {
        main: "#6b6efe",
      },
      success: {
        main: "#4caf50",
      },
      warning: { main: "#ff9800" },
      error: { main: "#f44336" },
      text: {
        primary: "#ffffff",
        secondary: "#fafafa",
      },
    },
    typography: {
      fontFamily: "sans-serif",

      h1: {
        color: "#ebebeb",
      },
      h2: {
        color: "#ebebeb",
      },
      h3: {
        color: "#ebebeb",
      },
      h4: {
        color: "#ebebeb",
      },
      h5: {
        color: "#ebebeb",
      },
      h6: {
        color: "#ebebeb",
      },
      subtitle1: {
        color: "#a1a1a1",
      },
      subtitle2: {
        color: "#a1a1a1",
      },
      body1: {
        color: "#a1a1a1",
      },
      body2: {
        color: "#a1a1a1",
      },
      button: {
        color: "#a1a1a1",
      },
      caption: {
        color: "#a1a1a1",
      },
      overline: {
        color: "#a1a1a1",
      },

      // add more typography styles as needed
    },

    components: {
      //buttons for dark modes

      MuiButton: {
        variants: [
          {
            props: { variant: "contained", color: "primary" },
            style: {
              backgroundColor: "#3f51b5",
              color: "#ffffff",
            },
          },
          {
            props: { variant: "outlined", color: "primary" },
            style: {
              borderColor: "#3f51b5",
              color: "#3f51b5",
            },
          },
          {
            props: { variant: "text", color: "primary" },
            style: {
              color: "#ebebeb",
            },
          },
          {
            props: { variant: "contained", color: "secondary" },
            style: {
              backgroundColor: "#f50057",
              color: "#ffffff",
            },
          },
          {
            props: { variant: "outlined", color: "secondary" },
            style: {
              borderColor: "#f50057",
              color: "#f50057",
            },
          },
          {
            props: { variant: "text", color: "secondary" },
            style: {
              color: "#f50057",
            },
          },
        ],
      },
    },
  });

  return (
    <ThemeProvider theme={themeMode === "light" ? lightTheme : darkTheme}>
      <Box sx={{ display: "flex" }}>
        <ScrollToTop />
        <CssBaseline />
        <Header />
        <Box
          component="main"
          sx={{
            backgroundColor: "background.default",
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />
          <Container maxWidth="xl" sx={{ mt: "30px" }}>
            <Content />
            <Footer />
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Layout;
